import React, { type HTMLAttributes, useContext } from 'react';
import styled from 'styled-components';
import { AccordionContext, type UUID } from './accordion';
import { ItemContext } from './accordionItem';
import { Spacing16 } from 'autogen/design-tokens/tokens';

export const AccordionItemButtonElement = styled.button`
    display: block;
    width: 100%;
    background: none;
    border: 0;
    padding: ${Spacing16};
`;

export default function AccordionItemButton(props: HTMLAttributes<HTMLDivElement>): JSX.Element {
    const { className, children } = props;
    const { expandedItems, updateExpandedItems, allowMultipleExpanded, allowZeroExpanded } =
        useContext(AccordionContext);
    const { uuid, isExpanded } = useContext(ItemContext);

    function collapse(): UUID[] {
        const remaining = expandedItems.filter((item): boolean => item !== uuid);

        if (remaining.length > 0) {
            return remaining;
        }

        return allowZeroExpanded ? remaining : expandedItems;
    }

    function expand(): UUID[] {
        return allowMultipleExpanded ? [...expandedItems, uuid] : [uuid];
    }

    function handleToggleItem(): void {
        updateExpandedItems(isExpanded ? collapse() : expand());
    }

    return (
        <AccordionItemButtonElement type="button" className={className} onClick={handleToggleItem}>
            {children}
        </AccordionItemButtonElement>
    );
}
